import { render, staticRenderFns } from "./myGift.vue?vue&type=template&id=baff311e&"
import script from "./myGift.vue?vue&type=script&lang=js&"
export * from "./myGift.vue?vue&type=script&lang=js&"
import style0 from "./myGift.vue?vue&type=style&index=0&id=baff311e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports